import {
	MeetingObjection,
	MeetingPhase,
	MeetingProfile,
	MeetingScoreLabel,
	MeetingTopicScores
} from "@/services/MeetingAnalyzerService"
import { themeColors } from "letalkui"

export type ScoreColorDefinition = {
	dotColor: string
	textColor: string
	badgeBackground: string
}

export const scoreLabelToColor: Record<MeetingScoreLabel, ScoreColorDefinition> = {
	Alto: {
		dotColor: themeColors.colors.success[600],
		textColor: themeColors.colors.success[700],
		badgeBackground: themeColors.colors.success[100]
	},
	Medio: {
		dotColor: themeColors.colors.warning[600],
		textColor: themeColors.colors.warning[700],
		badgeBackground: themeColors.colors.warning[100]
	},
	Baixo: {
		dotColor: themeColors.colors.error[600],
		textColor: themeColors.colors.error[700],
		badgeBackground: themeColors.colors.error[100]
	}
}

export const scoreLabelToDisplayText: Record<MeetingScoreLabel, string> = {
	Alto: "Alto",
	Medio: "Médio",
	Baixo: "Baixo"
}

export const profileToDisplayText: Record<MeetingProfile, string> = {
	aggressive: "Agressivo",
	balanced: "Equilibrado",
	passive: "Passivo",
	technical: "Técnico"
}

export const objectionToDisplayText: Record<MeetingObjection, string> = {
	price: "Preço",
	timing: "Timing",
	authority: "Autoridade",
	need: "Necessidade",
	trust: "Confiança"
}

export const phaseToDisplayText: Record<MeetingPhase, string> = {
	opening: "Abertura",
	discovery: "Anamnese",
	"pain-exploration": "Exploração de dor",
	"value-demonstration": "Demonstração de valor",
	"objection-handling": "Quebra de objeções",
	closing: "Fechamento"
}

export type TopicDefinition = {
	key: keyof MeetingTopicScores
	label: string
	weightInPercentage: number
}

export const meetingTopicDefinitions: TopicDefinition[] = [
	{
		key: "discovery",
		label: "Diagnóstico inicial (Anamnese)",
		weightInPercentage: 25
	},
	{
		key: "pain",
		label: "Exploração de dor",
		weightInPercentage: 20
	},
	{
		key: "value",
		label: "Demonstração clara de valor",
		weightInPercentage: 20
	},
	{
		key: "conduction",
		label: "Condução da reunião",
		weightInPercentage: 20
	},
	{
		key: "closing",
		label: "Fechamento e geração de urgência",
		weightInPercentage: 15
	}
]

export const getScoreQualityLabel = (score: number): string => {
	if (score >= 75) {
		return "Bom"
	}

	if (score >= 50) {
		return "Regular"
	}

	return "Ruim"
}

export const getScoreQualityColor = (score: number): string => {
	if (score >= 75) {
		return themeColors.colors.success[600]
	}

	if (score >= 50) {
		return themeColors.colors.warning[600]
	}

	return themeColors.colors.error[600]
}

const HIGH_SCORE_THRESHOLD = 70
const MEDIUM_SCORE_THRESHOLD = 40

export const getScoreLabel = (score: number): MeetingScoreLabel => {
	if (score >= HIGH_SCORE_THRESHOLD) {
		return "Alto"
	}

	if (score >= MEDIUM_SCORE_THRESHOLD) {
		return "Medio"
	}

	return "Baixo"
}
